import styled from 'styled-components'

export const Lazy = styled.div``

export const ComponentWrapper = styled.div`
  background-color: ${({ isUserLoggedIn, theme }) => (isUserLoggedIn ? theme.colors.secondary.lighten : '#FFFF')};
`
export const GreyBard = styled.div`
  height: 32px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.secondary.ultraLighten};
`
